import React from 'react'
import { xinyiResearchItems } from './content'
import type { Lang } from './types'

interface XinyiResearchV2Props {
  currentLang: Lang
}

/**
 * XinyiResearchV2
 * Three alternating splits — Research / Quality / Roasting & Brewing.
 * Reuses Barista Map asymmetrical 7/5 grid; alternating mediaPosition.
 */
const XinyiResearchV2: React.FC<XinyiResearchV2Props> = ({ currentLang }) => {
  return (
    <div className="bg-[#FAF9F1]">
      {xinyiResearchItems.map((item, idx) => {
        const isMediaRight = item.mediaPosition === 'right'

        return (
          <section
            key={idx}
            className={`py-16 md:py-24 ${idx % 2 === 1 ? 'bg-white' : 'bg-[#FAF9F1]'}`}
          >
            <div className="mx-auto max-w-[1600px] px-6 md:px-10">
              <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:items-center md:gap-16">
                {/* Image */}
                <div
                  className={`md:col-span-7 ${isMediaRight ? 'md:order-2' : 'md:order-1'}`}
                >
                  <div className="relative aspect-square w-full overflow-hidden md:aspect-[4/5]">
                    <img
                      src={item.image}
                      alt={item.imageAlt[currentLang]}
                      className="absolute inset-0 h-full w-full object-cover"
                    />
                  </div>
                </div>

                {/* Copy */}
                <div
                  className={`md:col-span-5 ${
                    isMediaRight ? 'md:order-1 md:pr-6' : 'md:order-2 md:pl-6'
                  }`}
                >
                  <p
                    className="mb-5 text-[12px] tracking-[0.22em] text-black/65"
                    style={{
                      fontFamily: "'EB Garamond', serif",
                      fontStyle: 'italic',
                      fontWeight: 400,
                    }}
                  >
                    / {item.tag} /
                  </p>

                  <h2
                    className="mb-6 text-black"
                    style={{
                      fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
                      fontWeight: 400,
                      fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
                      letterSpacing: '0.04em',
                      lineHeight: 1.25,
                    }}
                  >
                    {item.title[currentLang]}
                  </h2>

                  <div className="mb-6 h-px w-12 bg-black/30" />

                  <p
                    className="whitespace-pre-line text-[15px] leading-loose text-black/75"
                    style={{
                      fontFamily: "'Noto Serif TC', 'Noto Sans TC', sans-serif",
                      fontWeight: 300,
                      letterSpacing: '0.03em',
                    }}
                  >
                    {item.body[currentLang]}
                  </p>
                </div>
              </div>
            </div>
          </section>
        )
      })}
    </div>
  )
}

export default XinyiResearchV2
